module.exports = __webpack_public_path__ + "team-work-672018b2.webp";